require("./modules/site-wide-header.js");
require("./modules/header-search.js");
require("./modules/animations.js");
require("./modules/messages.js");

const Alert = require("./modules/alert.js");
new Alert();
const CUCookie = require("./modules/cookie");
new CUCookie();

// add top logo if scroll depth is greater than 80
document.addEventListener("scroll", function () {
  const logo = document.getElementById("logo-scroll");

  if (window.scrollY >= 84) {
    logo.classList.add("visible");
  } else {
    logo.classList.remove("visible");
  }
});

(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.cuDepartmentMenuFix = {
    attach: function (context, settings) {
      // 1. SAFE SELECTOR: Target the parent wrapper contextually.
      // 'once' ensures this only runs exactly once per menu header block, 
      // preventing infinite loops during AJAX actions.
      const headers = once('cu-menu-cleanup', '.department-menu__header h2', context);

      headers.forEach(function (heading) {
        // 2. CHECK EXTISTENCE: heading is guaranteed to be an actual DOM element here
        let htmlContent = heading.innerHTML;

        if (htmlContent) {
          // Strip out Typogrify's ampersand spans if they linger
          htmlContent = htmlContent.replace(/<span class="amp">/g, '');
          htmlContent = htmlContent.replace(/<\/span>/g, '');

          // Smash the standard text entity, standard binary spaces, and thin spaces (\u2006)
          htmlContent = htmlContent.replace(/&amp;nbsp;/g, ' ');
          htmlContent = htmlContent.replace(/&nbsp;/g, ' ');
          htmlContent = htmlContent.replace(/\u00A0/g, ' '); // Standard non-breaking space
          htmlContent = htmlContent.replace(/\u2006/g, ' '); // Thin non-breaking space

          // 3. SAFE RE-ASSIGNMENT
          heading.innerHTML = htmlContent;
        }
      });
    }
  };

})(jQuery, Drupal, once);

